<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Process"
    }
</script>

<style scoped>

</style>
